import { LogOut, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/site/Seo";
import { AdminLoginCard } from "@/components/site/admin/AdminLoginCard";
import { AdminPostEditor } from "@/components/site/admin/AdminPostEditor";
import { AdminPostsTable } from "@/components/site/admin/AdminPostsTable";
import { useAdminInsights } from "@/hooks/useAdminInsights";

export default function AdminInsightsPage() {
  const {
    auth,
    posts,
    editing,
    form,
    loading,
    setField,
    handleAuthenticated,
    handleLogout,
    startEdit,
    resetForm,
    handleSubmit,
    handleDelete,
    togglePublish,
    reload,
  } = useAdminInsights();

  if (auth !== true) {
    return <AdminLoginCard onAuthenticated={handleAuthenticated} titleKey="blog" />;
  }

  return (
    <div data-testid="admin-insights-page">
      <Seo title="Admin · Blog" path="/admin-clan/blog" noindex />
      <section className="mx-auto w-full max-w-6xl px-4 pb-16 pt-10 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-blue-700">Admin</div>
            <h1 className="mt-1 text-3xl font-extrabold tracking-tight text-slate-900">Blog console</h1>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              onClick={reload}
              className="h-10 rounded-lg border-slate-300 bg-white"
              data-testid="admin-refresh-button"
            >
              <RefreshCw className="mr-1.5 h-4 w-4" /> Refresh
            </Button>
            <Button
              variant="outline"
              onClick={handleLogout}
              className="h-10 rounded-lg border-slate-300 bg-white"
              data-testid="admin-logout-button"
            >
              <LogOut className="mr-1.5 h-4 w-4" /> Sign out
            </Button>
          </div>
        </div>

        <AdminPostEditor
          form={form}
          editing={editing}
          loading={loading}
          setField={setField}
          onSubmit={handleSubmit}
          onCancel={resetForm}
        />

        <AdminPostsTable
          posts={posts}
          onTogglePublish={togglePublish}
          onEdit={startEdit}
          onDelete={handleDelete}
        />
      </section>
    </div>
  );
}
